const asArray = (value) => (Array.isArray(value) ? value : []);

/**
 * Resolves sales representatives for presentation only. Returned arrays reuse
 * the supplied objects and must never be persisted as role assignments.
 */
const resolveDisplayedSalesReps = ({
  clientReps = [],
  orderReps = [],
  administrators = [],
} = {}) => {
  const actualClientReps = asArray(clientReps);
  const actualOrderReps = asArray(orderReps);
  const adminFallback = asArray(administrators);

  return {
    clientReps: actualClientReps.length
      ? actualClientReps
      : (actualOrderReps.length ? actualOrderReps : adminFallback),
    orderReps: actualOrderReps.length
      ? actualOrderReps
      : (actualClientReps.length ? actualClientReps : adminFallback),
  };
};

module.exports = { resolveDisplayedSalesReps };
